import React, { useEffect, useRef } from "react"
import { Button, TextTag } from "../../atoms"
import _ from "../../utils/lodashUtils"
import { PageHeader } from "../../molecules/PageHeader"
import "./GetReady.scss"
import {
  ORDER_TOGETHER,
  NEXT_BUTTON,
  NEXT_INFO,
  GET_READY_DINNER,
  BACK_BUTTON,
  DEFAULT_SPACE_NAME,
  CUI_EMBED_URL,
  GET_CAT_IMAGE,
} from "../../constants/messages"
import { FirebaseService, FirebaseContext } from "../../firebase"
import { FIREBASE_STATE_KEYS } from "../../firebase"
import { ArrowLeftOutlined } from "@ant-design/icons"
import Separator from "../Separator/Separator"
import { CUSTOM_EVENTS } from "../../constants/commons"
import { emitter } from "../../utils/emitter"

const GetReadyPage = (props) => {
  const firebaseDefaultPath = FirebaseService.getDefaultPath()
  const { dateState } = React.useContext(FirebaseContext)
  const chatSpaceName =
    _.get(
      dateState,
      "chatSpaceName",
      _.get(props.partners, "chat_space_name", DEFAULT_SPACE_NAME)
    ) || DEFAULT_SPACE_NAME
  const chatBotRef = useRef()
  const scrollToBottom = () => {
    chatBotRef.current.scrollIntoView({ behavior: "smooth" })
  }
  useEffect(() => {
    scrollToBottom()
    // const script = document.createElement("script")
    // script.src = CUI_EMBED_URL
    // script.async = true
    // document.body.appendChild(script)
    const landbotScript = document.createElement('script');
    landbotScript.type = 'text/javascript';
    landbotScript.innerHTML = `var myLandbot = new Landbot.Container({
      container: '#myLandbot',
      configUrl: 'https://chats.landbot.io/v3/H-658884-E7W8N2KRMH5OFUF5/index.json',
    })`
    document.body.appendChild(landbotScript)
    var urlCustomAvatar = 'https://robohash.org/' + chatSpaceName + '?set=set4'

    /*DO NOT EDIT BELOW THIS LINE*/
// var avatares = this.document.querySelectorAll(".Avatar:not(.avatarOriginal)")
// window.cssRuleApplied;
// if(window.cssRuleApplied != true){
// for (var i=0; i< avatares.length; i++){
// avatares[i].classList.add('avatarOriginal');
// window.cssRuleApplied = true
// }
// }
// var cssRule = `.Avatar:not(.avatarOriginal) {content: url(${picUrl})!important;}`
// this.document.styleSheets[0].insertRule(cssRule);
/*DO NOT EDIT ABOVE THIS LINE*/

    //DO NOT EDIT BELOW THIS LINE// 
  //  var holderUrl = `url(${urlCustomAvatar})` 
  //  myLandbot.on('landbot-load', () => { 
  //   window.document.getElementsByClassName("LandbotProactive__frame__content")[0].contentDocument.body.childNodes[0].childNodes[0].childNodes[3].childNodes[1].childNodes[0].childNodes[0].childNodes[0].style.backgroundImage = holderUrl
  // }); 
  
    return () => {
      document.body.removeChild(landbotScript)
    }
  }, [])
  /* Back to Plan a date screen Modal Emitter Registry and toggling modal */

  return (
    <div id="getAddressPage">
      <PageHeader
        onClick={() => {
          FirebaseService.patch(
            {
              [FIREBASE_STATE_KEYS.GET_READY]: "PLAN_DATE",
            },
            `${firebaseDefaultPath}${props.userUuid}`
          )
        }}
        icon={<ArrowLeftOutlined />}
        headerText={GET_READY_DINNER}
        btnText={BACK_BUTTON}
      />
      <section className="date-chat-window">
        <div className="container">
          <>
            <TextTag className="sub-heading-text" textType="bodyHeading">
              {ORDER_TOGETHER}
            </TextTag>
          </>
          <>
            <Button
              btnType="primary"
              btnSize="large"
              onClick={() => {
                emitter.fire(CUSTOM_EVENTS.SHOW_READY_PAGE_MODAL, [])
              }}
            >
              {NEXT_BUTTON}
            </Button>
          </>
        </div>
        <Separator />
        <div className="footer">
          <TextTag textType="sectionTextPrimary">
            {NEXT_INFO(chatSpaceName || DEFAULT_SPACE_NAME, props.partnerName)}
          </TextTag>
        </div>
      </section>
      <section className="bot-chat-window" ref={chatBotRef}>
        <div id="myLandbot" style={{width: "100%", height: "500px"}}></div>
      </section>
    </div>
  )
}

export default GetReadyPage
